import '../layouts/css/Footer.css'
import { Link } from "react-router-dom";

export default function Footer() {
    return <>
        <footer className='overflow'>
            <section>
                <section className="footer-bottom">
                    <p>
                        &copy; Edilizia Generale di Costantino <br />
                        La ditta è denominata "Ghiletchi Constantin" (alias "Costantino") <br />
                        P.IVA: 11924880013 <br />
                        Indirizzo: <a className="designer" href="https://maps.app.goo.gl/MwpSwXV1Gz6moe4t7" target="_blank" rel="noreferrer">Via Cavagnolo 12, int. 34, Torino </a> <br />
                        Mail: <a className="designer" href="https://mail.google.com/mail/u/0/?view=cm&fs=1&to=Edilctorino@gmail.com" target="_blank" rel="noreferrer">Edilctorino@gmail.com</a> <br />
                        Telefono: 327 972 9935 <br />
                        Facebook: <a className="designer" target="_blank" rel="noreferrer" href="https://www.facebook.com/profile.php?id=61566510724792">Nica Bagni Torino</a> <br />
                        Instagram: <a className="designer" target="_blank" rel="noreferrer" href="https://www.instagram.com/nica.bagni.torino/">nica.bagni.torino</a> <br />
                        <Link className="designer" to="/privacy">Informativa sulla Privacy</Link>
                    </p>
                </section>
            </section>
        </footer>
    </>
}